/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from "react";
import { Nav, OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import { Save, RotateLeft, PlayCircleOutline } from "@material-ui/icons";
import TabBarRenderer from "./TabBarRenderer";
import Notify from "./Notify";
import ConfirmPopup from "./ConfirmPopup";
import { useEngineStore } from "./store/engineStore";

function EnginePanel({ templateConfig }) {
  const [activeTab, setActiveTab] = useState("Product Info");
  const [currentComponent, setCurrentComponent] = useState(null);
  const [isConfirmActive, setConfirmActive] = useState(false);
  const [Icons, setIcons] = useState({});

  const {
    interactiveConfig,
    isPageLoading,
    isAssetsUploading,
    showNotify,
    notifyMessage,
    setNotifyMessage,
  } = useEngineStore((state) => ({
    interactiveConfig: state.interactiveConfig,
    isPageLoading: state.isPageLoading,
    isAssetsUploading: state.isAssetsUploading,
    showNotify: state.showNotify,
    notifyMessage: state.notifyMessage,
    setNotifyMessage: state.setNotifyMessage,
  }));

  useEffect(() => {
    if (interactiveConfig?.heirarchy?.length > 0) {
      setActiveTab("3D Interactivity");
    }
  }, [interactiveConfig]);

  useEffect(() => {
    if (activeTab) {
      const currentComponentConfig = templateConfig.components.find(
        (c) => c.title === activeTab
      );
      setCurrentComponent(currentComponentConfig);
    }
  }, [activeTab, templateConfig.components]);

  useEffect(() => {
    import("./icons" /* webpackChunkName: "EngineTabIcons" */)
      .then((mod) => {
        console.log("fetching icons for engine...");
        console.log(mod?.default);
        setIcons(mod?.default);
      })
      .catch((err) => console.log(err));
  }, []);

  if (isPageLoading) {
    return (
      <div className="sideNavContainer">
        <div className="loadingContainer">
          <div className="loader" />
        </div>
      </div>
    );
  }

  return (
    <div className="sideNavContainer">
      <Nav defaultActiveKey="Product Info" className="sideNavWrapper">
        {templateConfig.components.map((component) => {
          if (!component.enabled) return null;
          return (
            <OverlayTrigger
              key={component.title}
              placement="bottom"
              overlay={<Tooltip id="tooltip-bottom">{component.title}</Tooltip>}
            >
              <Nav.Item
                className={`sideNavItem ${
                  component.title === activeTab && "activeNavItem"
                }`}
                onClick={() => {
                  setActiveTab(component.title);
                  setCurrentComponent(component);
                }}
              >
                <div className="navItemContent">
                  <img
                    src={
                      activeTab === component.title
                        ? Icons[component.activeIcon]
                        : Icons[component.icon]
                    }
                    width="30"
                    height="30"
                  />
                </div>
              </Nav.Item>
            </OverlayTrigger>
          );
        })}
      </Nav>
      <div
        className="settingsPanelWrapper"
        id="nav-vertical-tabpanel"
        aria-labelledby="nav-vertical-tab"
      >
        <TabBarRenderer
          activeTab={activeTab}
          templateConfig={templateConfig}
          interactiveConfig={interactiveConfig}
        />
      </div>
      {currentComponent?.enableActions && (
        <div className="footer">
          <div className="actionContainer">
            <Button
              className="submitAction"
              onClick={async () => {
                templateConfig.submitSkuConfig();
              }}
              disabled={isAssetsUploading}
              type="secondary"
            >
              <div>Save</div>
              <Save fontSize="small" />
            </Button>
            <Button
              className="resetAction"
              onClick={async () => {
                setConfirmActive(true);
              }}
              type="secondary"
            >
              <div>Reset</div>
              <RotateLeft fontSize="small" />
            </Button>
            <Button
              className="previewAction"
              disabled={!templateConfig?.enableRendererPreview()}
              onClick={async () => {
                let currentURL = window.location.href;
                const regex = new RegExp(`(mode=)[^&]+`);
                currentURL = currentURL.replace(regex, `mode=renderer`);
                window.open(`${currentURL}&ar=1`);
              }}
              type="secondary"
            >
              <div>Preview in 3D</div>
              <PlayCircleOutline fontSize="small" />
            </Button>
          </div>
        </div>
      )}
      <Notify
        message={notifyMessage}
        show={showNotify}
        onClose={() => {
          setNotifyMessage({ showNotify: false, notifyMessage: "" });
        }}
      />
      <ConfirmPopup
        showModal={isConfirmActive}
        onCloseColorSlot={() => setConfirmActive(false)}
        onSaveSlotData={async () => window.location.reload()}
      />
    </div>
  );
}

export default EnginePanel;
